export default __webpack_public_path__ + "static/media/23.0a228f33.jpg";